import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
type Plan = {
  name: string;
  ideal: string;
  was?: string;
  now: string;
  features: string[];
  cta: string;
  featured: boolean;
};
const plans: Plan[] = [{
  name: '📘 MegaPack Universitario Elite',
  ideal: 'Estudiantes que quieren aprobar sin recursar más',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  features: ['12 Tomos completos', 'Técnicas de retención y memoria', 'Protocolo Anti-Bloqueo en exámenes', 'Organización de cuatrimestre ARG', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: 'Quiero el MegaPack +5 Bonos',
  featured: false
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="w-full overflow-x-hidden bg-radial-glow" data-id="element-139" data-mp="3vyf6apizgw0s">
      <div className="mx-auto w-full max-w-5xl px-5 py-20 pb-[23px] pt-[18px]" data-id="element-140" data-mp="4s4cnegayxjh">
        <div className="mx-auto grid w-full max-w-md items-stretch gap-6" data-id="element-141" data-mp="9rp6jagm8fpc">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={plan.featured ? 'relative flex w-full flex-col items-center rounded-3xl border border-gold/60 bg-ink-2 px-7 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(229,185,75,0.45)]' : 'relative flex w-full flex-col items-center rounded-3xl border border-verde/35 bg-ink-2 px-7 pb-7 pt-10 text-center'} style={{
          paddingLeft: "13px",
          paddingRight: "6px"
        }} data-id="element-142" data-mp="erv2h2tx4od8" data-mpi={i}>
              {plan.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-gold px-4 py-1 text-[11px] font-black uppercase tracking-wide text-ink" data-id="element-143" data-mp="2zh13obc087xp">
                  <StarIcon className="h-3 w-3 fill-current" data-id="element-144" data-mp="2mibfhi2qssnh" /> Más completo
                </span>}

              <h3 className="font-display text-lg font-black text-white" data-id="element-145" data-mp="3177haxe7h9fn">{plan.name}</h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-146" data-mp="2w7uyqoudaoiv">
                <span className="font-semibold text-white/80" data-id="element-147" data-mp="2w8d1837mhyz8">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-148" data-mp="28k3acmvjyl18">
                {plan.was && <span className="text-base font-medium text-white/40 line-through" data-id="element-149" data-mp="23jpdm0zeixii">{plan.was}</span>}
                <div className="font-display text-4xl font-black text-gold-shine" data-id="element-150" data-mp="2iggb24pilz5h">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-verde-soft" data-id="element-151" data-mp="2dgtxfu5rygw5">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-152" data-mp="3ow8usz1wbars">
                {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-153" data-mp="adk6o7c5phy">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-154" data-mp="cqcnvapzi99" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-155" data-mp="3ngel3ob8iu2c">
                <CTAButton size="md" href="https://megapack-universitario-elite.impultienda.ar/checkout" variant={plan.featured ? 'gold' : 'verde'} className="w-full" data-id="element-156" data-mp="3nhfuloclr8hy">
                  {plan.cta}
                </CTAButton>
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-157" data-mp="nywtn724g8bm">
                {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="e9d97wyrg6en">
                    <Icon className="h-4 w-4 text-verde-soft" data-id="element-159" data-mp="11zzfbip7fgm0" />
                    {label}
                  </span>)}
              </div>
            </motion.div>)}
        </div>

        <MoreTestimonials data-id="element-160" data-mp="16sk4u812v7jq" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-verde/30 bg-verde/10 p-5 text-left" style={{
        paddingLeft: "7px",
        paddingRight: "16px",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "normal"
      }} data-id="element-161" data-mp="3f78qa81c93cj">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" style={{
          width: "24px",
          height: "25px"
        }} data-id="element-162" data-mp="35bfa8eoeurq0" />
          <p className="text-sm leading-relaxed text-white/75" style={{
          fontSize: "15px",
          color: "#DBB249"
        }} data-id="element-163" data-mp="1schl9c4lg4x">
            <span className="font-bold text-white" style={{
            fontSize: "14px",
            fontWeight: "700",
            fontFamily: "Cinzel, serif",
            color: "#DBB249"
          }} data-id="element-164" data-mp="3szyfsmg2sqee">Garantía de devolución de 7 días.</span> Si abrís
            los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y
            te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}